import {Head, router, usePage} from '@inertiajs/react'
import Layout from "../../components/layout";
import {CameraIcon, PhotoIcon,} from "@heroicons/react/24/outline";
import {useCallback, useEffect, useRef, useState} from "react";
import toast from "react-hot-toast";
import 'react-tooltip/dist/react-tooltip.css'
import {Tooltip} from 'react-tooltip';
import 'react-responsive-modal/styles.css';
import {Modal} from 'react-responsive-modal';
import AuthForm from '../../components/authForm.jsx';
import * as Sentry from '@sentry/react';
import {useWebPush} from '../../hooks.js';

function InstallPopup() {
    return <div className="text-black">
        <p className="text-center">Please install this webapp for a better experience</p>
        <p className="flex font-semibold justify-center flex-row items-center">Tap
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"
                 className="w-6 h-6 text-blue-500 mx-1">
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path
                    d="M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2z"
                    fill="currentColor" />
            </svg>
            below and then&nbsp;<span className="text-blue-500">Add to Home Screen</span>
        </p>
    </div>
}

export default function CameraIndex({has_account, event: initialEvent, logoUrl, webPushUrl, uploadUrl}) {
    const {auth} = usePage().props
    const tooltipRef = useRef(null);
    const [event, setEvent] = useState(initialEvent);
    const [tempImage, setTempImage] = useState(null);
    const [open, setOpen] = useState(false);
    const [openAuth, setOpenAuth] = useState(false);

    const {request} = useWebPush(webPushUrl);

    const onCloseModal = useCallback(() => {
        setOpen(false);
    }, []);

    const onPhotosViewPressed = useCallback(() => {
        // if (event.reveal_type === 'hidden' && !event.is_organizer) {
        //     setOpen(true);
        //     return;
        // }
        router.get(`/camera/${event.id}/photos`)
    }, [event, has_account]);

    useEffect(() => {
        if (auth.user.name && !has_account && localStorage.getItem('camera_has_account_prompted') !== '1' && event.photos_taken > 0) {
            setOpenAuth(true);
            localStorage.setItem('camera_has_account_prompted', '1')
        }
    }, [has_account, auth.user, event.photos_taken])

    const onScreenshotPress = useCallback(async (takeEvent) => {

        console.log('onScreenshotPress');
        const shot = takeEvent.target.files[0];
        console.log(shot);
        takeEvent.target.value = null;
        if (event.photos_taken >= event.photo_limit && !event.unlimited_photos) {
            toast.error('You have no more photos left');
            return;
        }

        if (!shot) {
            console.warn('shot is null');
            return;
        }

        const imageUrl = URL.createObjectURL(shot);
        setTempImage(imageUrl);

        const formData = new FormData();

        formData.append('file', shot, 'image.jpeg');
        formData.append('generate_blurhash', true);

        try {
            request();
            const requestStartedAt = new Date().getTime();
            await toast.promise(
                axios.post(uploadUrl, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }),
                {
                    loading: 'Uploading photo...',
                    success: function () {
                        Sentry.metrics.gauge("upload_time", new Date().getTime() - requestStartedAt, {
                            tags: {type: 'camera'},
                            unit: "millisecond",
                        });

                        setEvent(e => ({
                            ...e,
                            photos_taken: e.photos_taken + 1
                        }))
                        return 'Photo uploaded ✅';
                    },
                    error: function (error) {
                        Sentry.metrics.gauge("upload_time", new Date().getTime() - requestStartedAt, {
                            tags: {type: 'camera'},
                            unit: "millisecond",
                        });
                        if (error.response && error.response.status !== 400) {
                            Sentry.captureException(error);
                            return 'Failed to upload photo. Do you have an internet connection?';
                        }
                        if (error.response && error.response.data) {
                            return error.response.data.message
                        }
                        console.warn(error);
                        return 'Failed to upload photo. Do you have an internet connection?';

                    }
                }
            )
            if (!auth.user.name) {
                router.reload()
            }
        } catch (e) {
            console.warn(e);
        } finally {
            setTempImage(null);
        }
    }, [event, auth.user]);

    useEffect(() => {
        const isIos = () => {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return /iphone|ipad|ipod/.test(userAgent);
        }
        const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

        if (isIos() && !isInStandaloneMode() && !localStorage.getItem('popup_seen')) {
            setTimeout(() => {
                localStorage.setItem('popup_seen', true)
                tooltipRef.current?.open(
                    {
                        anchorSelect: '#tooltip-element',
                        place: 'top',
                    }
                )
                setTimeout(() => {
                    tooltipRef.current?.close();
                }, 10000);
            }, 100)
        }
    }, []);

    return (
        <Layout>
            <Head title={event.name + ' - Camera'} />
            <div className="flex flex-col px-[20px] flex-grow justify-between h-full full-screen orient">
                {/*{event.reveal_type === 'hidden' && !event.is_organizer && <Modal open={open} onClose={onCloseModal} center>*/}
                {/*    {event.reveal_type === 'hidden' && <div>*/}
                {/*        <h2 className="font-bold text-xl">Album will not be revealed.</h2>*/}
                {/*        <p className="text-sm">The organizer of this event chose to <span*/}
                {/*            className="font-semibold">not</span> reveal the photos after the event. But all photos you*/}
                {/*            take will end up in the album for the organizer to enjoy after this event.</p>*/}
                {/*    </div>}*/}
                {/*</Modal>}*/}
                {(event.reveal_type === 'after' || event.reveal_type === 'during') && !has_account &&
                    <Modal open={openAuth} onClose={() => setOpenAuth(false)} center>
                        <AuthForm isAfter={event.reveal_type === 'after'} event={event} />
                    </Modal>}
                <div className="flex items-center mt-[20px] justify-between">
                    <div
                        className="flex opacity-0 flex-row items-center border-2 border-[#2F2F2F] bg-[rgba(41,41,41,0.70)] rounded-[20px] p-[7px]">
                        <PhotoIcon className="w-[25px] h-[25px] text-white" />
                    </div>
                    <div
                        className="flex flex-row items-center border-2 border-[#2F2F2F] bg-[rgba(41,41,41,0.70)] rounded-[20px] p-[7px]">
                        <CameraIcon className="w-[25px] mr-2 h-[25px] text-white" />
                        <div className="flex flex-row items-center">
                            <span
                                className="text-white text-lg font-bold">{event.unlimited_photos ? event.photos_taken : event.photo_limit - event.photos_taken} /</span>
                            {event.unlimited_photos ?
                                <svg className="text-white ml-1" xmlns="http://www.w3.org/2000/svg" width="32"
                                     height="32" fill="currentColor"
                                     viewBox="0 0 256 256">
                                    <path
                                        d="M252,128a60,60,0,0,1-102.43,42.43l-.49-.53L89.22,102.31a36,36,0,1,0,0,51.38l3.08-3.48a12,12,0,1,1,18,15.91l-3.35,3.78-.49.53a60,60,0,1,1,0-84.86l.49.53,59.86,67.59a36,36,0,1,0,0-51.38l-3.08,3.48a12,12,0,1,1-18-15.91l3.35-3.78.49-.53A60,60,0,0,1,252,128Z"></path>
                                </svg>
                                : <span className="text-white text-lg font-bold">&nbsp;{event.photo_limit}</span>}
                        </div>
                    </div>
                    <button
                        className="flex flex-row items-center border-2 border-[#2F2F2F] bg-[rgba(41,41,41,0.70)] rounded-[20px] p-[7px]"
                        onClick={onPhotosViewPressed}>
                        <PhotoIcon className="w-[25px] h-[25px] text-white" />
                    </button>
                </div>
                <div>
                    <div className="rounded-[50px] overflow-hidden bg-gray-900">
                        <div className={`aspect-[0.9]`}>
                            <div
                                className={`flex w-full h-full`}>
                                {tempImage && <img src={tempImage}
                                                   className={`flex object-cover w-full h-full`} />}
                                <input onChange={onScreenshotPress} id="capture-camera" className="hidden opacity-0"
                                       type="file"
                                       name="file" accept="image/*"
                                       capture="environment" />
                                <label htmlFor="capture-camera" className={tempImage ? 'hidden' : 'flex w-full h-full'}>
                                    <div className="w-full flex-col h-full items-center justify-center flex">
                                        <img className="size-20 mb-2" src={logoUrl} alt="" />
                                        <h3 className="text-primary-500 text-lg font-semibold">Tap here to open
                                            camera</h3>
                                        <p className="text-white text-center text-sm px-10">Tap here to open camera and
                                            take pictures for the album.</p>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mb-[30px] flex items-center justify-center">
                    <label
                        htmlFor="capture-camera"
                        className="w-[85px] h-[85px] border-[7px] bg-white border-primary-500 rounded-full" />
                </div>
                <div id="tooltip-element">
                    <Tooltip style={{
                        backgroundColor: 'white',
                    }} ref={tooltipRef}>
                        <InstallPopup />
                    </Tooltip>
                </div>
            </div>
        </Layout>
    )
}
